import React, { createContext, useContext, useState } from 'react';
import {setLogInData} from "../components/LogIn";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);

    const login = async (username, password) => {
        const authHeader = "Basic " + btoa(`${username}:${password}`);

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/authenticate`, {
            method: "GET",
            headers: { Authorization: authHeader, Accept: "application/json" },
        });

        const text = await response.text();
        const data = text ? (() => { try { return JSON.parse(text); } catch { return {}; } })() : {};

        if (!response.ok) {
            throw new Error(data?.message || "Login failed");
        }

        const rawProfilerUrl =
            process.env.REACT_APP_PROFILER_URL ||
            "https://3di-profiler.net/authServlet?username=[username]&password=[password]&redirect=[redirectid]";

        const profilerUrl = rawProfilerUrl
            .replace("[username]", encodeURIComponent(username))
            .replace("[password]", encodeURIComponent(password));

        setLogInData(data.user, data.userId, profilerUrl, data.ibmRestricted);

        setUser({ userName: data.user, userId: data.userId });
        setToken(data.token);

        return data;
    };

    const logout = () => {
        setUser(null);
        setToken(null);
    };

    return (
        <AuthContext.Provider value={{ user, token, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
